import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ArtistAgency from '../ArtistAgency';
import ContactCard from '../ContactCard';
import { TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';

const ArtistContactSideCard = ({ profile, isLoggedIn, agreementData, goToTab }) => {
  const { t } = useTranslation();
  return (
    <>
      <ArtistAgency goToTab={goToTab} agreementData={agreementData} isSmall />
      <ContactCard
        contacts={get(profile, 'contacts', [])}
        hideInfo={!isLoggedIn}
        subTitle={t(`${TP}.m_ACCOUNT_TYPES_ARTIST`)}
        socialLinksTitle={t(`${TP}.FOLLOW_ARTIST_ON`)}
      />
    </>
  );
};

ArtistContactSideCard.propTypes = {
  profile: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  goToTab: PropTypes.func,
  agreementData: PropTypes.object,
};

ArtistContactSideCard.defaultProps = {
  isLoggedIn: false,
};

export default ArtistContactSideCard;
